import { NoteAudience } from './enums';
/**
 * True only for the two Depanneo-internal tiers. Deliberately NOT `!== ALL`:
 * during a rolling deploy a new web bundle can read a response from the old API
 * that carries no `audience` at all, and treating that as restricted would empty
 * the client-facing Notes tab for every org reader. Withholding is RLS's job,
 * not this helper's.
 */
export const isRestrictedNoteAudience = (audience) => audience === NoteAudience.DEPANNEO ||
    audience === NoteAudience.DEPANNEO_TECHNICIAN;
